import { styled } from '@mui/material';
import { Box } from 'ui';
import Welcome from '../components/Welcome';

interface IProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: IProps) => {
  return (
    <PageBox>
      <Welcome />
      <ContextBox>{children}</ContextBox>
    </PageBox>
  );
};

const PageBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100vh',
  boxSizing: 'border-box',
  background: theme.palette.background.default,
  display: 'flex'
}));

const ContextBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%'
}));

export const StoryPagesBox = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  position: 'fixed',
  boxSizing: 'border-box',
  top: 0,
  left: 0
}));
export default Layout;
